import { render, staticRenderFns } from "./Lazada.vue?vue&type=template&id=3dc9e4c2&"
import script from "./Lazada.vue?vue&type=script&lang=js&"
export * from "./Lazada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc9e4c2')) {
      api.createRecord('3dc9e4c2', component.options)
    } else {
      api.reload('3dc9e4c2', component.options)
    }
    module.hot.accept("./Lazada.vue?vue&type=template&id=3dc9e4c2&", function () {
      api.rerender('3dc9e4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Lazada.vue"
export default component.exports